import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';

// Card network logos, served from public/logos (self-hosted so they can't break)
export const CARD_NETWORKS = {
  visa: { label: 'Visa', logo: '/logos/visa.svg', height: { medium: 15, small: 11 } },
  mastercard: { label: 'Mastercard', logo: '/logos/mastercard.svg', height: { medium: 24, small: 17 } },
  rupay: { label: 'RuPay', logo: '/logos/rupay.svg', height: { medium: 17, small: 12 } },
  amex: { label: 'American Express', logo: '/logos/amex.svg', height: { medium: 26, small: 18 } },
};

// Card network logo shown on a white badge in its real colours, so it stays readable
// on every background. Falls back to the network name if the image can't load.
const CardNetworkLogo = ({ variant, size = 'medium', sx }) => {
  const [failed, setFailed] = useState(false);
  const network = CARD_NETWORKS[variant];
  const label = network?.label || 'Credit Card';
  const small = size === 'small';

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#fff',
        borderRadius: small ? 1 : 1.5,
        px: small ? 0.75 : 1,
        height: small ? 22 : 32,
        minWidth: small ? 36 : 48,
        boxShadow: small ? '0 0 0 1px rgba(15, 23, 42, 0.12)' : '0 1px 3px rgba(0, 0, 0, 0.2)',
        flexShrink: 0,
        ...sx
      }}
    >
      {network && !failed ? (
        <Box
          component="img"
          src={network.logo}
          alt={label}
          onError={() => setFailed(true)}
          sx={{ height: network.height[size], maxWidth: small ? 44 : 64, width: 'auto', objectFit: 'contain', display: 'block' }}
        />
      ) : (
        <Typography component="span" sx={{ fontSize: small ? '0.625rem' : '0.75rem', fontWeight: 700, color: '#1A1F71', whiteSpace: 'nowrap' }}>
          {label}
        </Typography>
      )}
    </Box>
  );
};

export default CardNetworkLogo;
